<script>
import { mapState, mapActions } from 'vuex';
/* components */
// import CustomComponent from '@/components/CustomComponent';
/* tools */
import { getGameImage } from '@/scripts/utils';
import { findGame } from '@/scripts/utils/collection';
import { getPlatformIconUrl } from '@/scripts/utils/data';

export default {
  name: 'GamesList',
  components: {
    // CustomComponent,
  },
  props: {
    connections: {
      type: Object,
    },
  },
  data() {
    return {
      accordions: {},
    };
  },
  computed: {
    ...mapState(['user', 'games']),
  },
  created() {},
  mounted() {},
  filters: {
    geGameTitle(id) {
      const game = findGame(id);
      const result = game ? game.title : '';
      /* const result = `${title} ${platformID ? `(${platformID})` : ''}`; */

      return result;
    },
  },
  methods: {
    ...mapActions({}),
    getStatusAction(status) {
      switch (status) {
        case 'not_connected':
        case 'disconnected':
          return { title: 'Connect' };
        case 'connected':
          return { title: 'Disconnect' };
        case 'failed':
          return { title: 'Try Again', showStatus: true };

        default:
          return { showStatus: true };
      }
    },
    /* TODO: not_connected, pending, failed, connected, disconnected */
    toggleConnected(game, setup) {
      // const {} = this;
      const { platformID, status, connectionID } = setup;
      const connectionRedirect = `/onboarding/connect-game/${game}${
        platformID ? `?platform=${platformID}` : ''
      }`;

      switch (status) {
        case 'not_connected':
        case 'disconnected':
        case 'failed':
          this.$router.push(connectionRedirect);

          break;
        case 'connected':
          this.$emit('disconnect', connectionID);

          break;

        default:
          console.log('status', status);
          break;
      }
    },
    checkIsMultiplatformGame(platforms) {
      const result = platforms.some(({ platformID }) => platformID);

      return result;
    },
    toggleAccordion(id) {
      this.$set(this.accordions, id, this.accordions[id] ? false : true);
    },
    multiPlatform(platforms, field) {
      const [multiPlatform] = platforms;
      const result = field ? multiPlatform[field] : multiPlatform;

      return result;
    },
    checkIsDisabled(id, platforms, platformIndex) {
      const platformSetup = platforms[platformIndex];
      const hasActive = platforms.some(
        ({ status }) => status === 'connected' || status === 'pending'
      );
      const gameSetup = findGame(id);
      const { allowMultipleConnections: multi } = gameSetup;
      const warn = hasActive && !multi;
      const result = false;

      if (warn) {
        return platformSetup.status !== 'connected';
      }

      return result;
    },
    findGame,
    getGameImage,
    getPlatformIconUrl,
  },
};
</script>

<template>
  <div class="list">
    <!-- > map = games -->
    <div v-for="(platforms, id) in connections" :key="id" class="list__item">
      <div class="game">
        <!-- > main -->
        <div class="game__top">
          <div class="game__img">
            <img :src="getGameImage(findGame(id))" />
          </div>
          <div class="game__content">
            <div class="game__content-wrapper">
              <div class="game__title">
                {{ id | geGameTitle }}
              </div>
              <!-- > map = game platforms (icons) -->
              <div class="game__platform">
                <div
                  v-if="checkIsMultiplatformGame(platforms)"
                  class="game__platforms"
                >
                  <img
                    v-for="platform in findGame(id).platforms"
                    :src="getPlatformIconUrl(platform.id)"
                    :key="platform.id"
                    class="game__platforms-icon"
                  />
                </div>
                <div class="game__subtitle" v-else>Multiplatform</div>
              </div>
            </div>
            <div
              class="game__content-status"
              v-if="
                !checkIsMultiplatformGame(platforms) &&
                  getStatusAction(multiPlatform(platforms, 'status')).showStatus
              "
            >
              <!-- passive status -->
              <div :class="['status', multiPlatform(platforms, 'status')]">
                <div class="status__text">
                  {{ multiPlatform(platforms, 'status') }}
                </div>
              </div>
            </div>
          </div>
          <div class="game__action">
            <div
              v-if="checkIsMultiplatformGame(platforms)"
              class="game__toggle"
              :class="{ active: accordions[id] }"
              @click="toggleAccordion(id)"
            >
              <span>show {{ accordions[id] ? 'less' : 'more' }}</span>
              <img
                :src="require('@/assets/svg/triangle-yellow.svg')"
                class="game__arrow"
              />
            </div>
            <div class="game__status" v-else>
              <!-- action -->
              <div
                v-if="getStatusAction(multiPlatform(platforms, 'status')).title"
                :class="['action', multiPlatform(platforms, 'status')]"
                @click="toggleConnected(id, multiPlatform(platforms))"
              >
                {{ getStatusAction(multiPlatform(platforms, 'status')).title }}
              </div>
            </div>
          </div>
        </div>
        <!-- < main-->
        <div
          v-if="checkIsMultiplatformGame(platforms)"
          :class="{ game__bottom: true, active: accordions[id] }"
        >
          <div class="platforms">
            <!-- > map = platforms (submenu) -->
            <div
              v-for="({ status, platformID, platformName }, i) in platforms"
              :key="i"
              :class="{
                platforms__row: true,
                disabled: checkIsDisabled(id, platforms, i),
              }"
            >
              <!--  -->
              <div class="platforms__icon">
                <img :src="getPlatformIconUrl(platformID)" />
              </div>
              <div class="platforms__content">
                <div class="platforms__title">
                  {{ platformName }}
                </div>
                <div
                  class="platforms__status"
                  v-if="getStatusAction(status).showStatus"
                >
                  <!-- passive status -->
                  <div :class="['status', status]">
                    <div class="status__text">
                      {{ status }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- action -->
              <div class="platforms__action">
                <div
                  v-if="getStatusAction(status).title"
                  :class="['action', status]"
                  @click="toggleConnected(id, platforms[i])"
                >
                  {{ getStatusAction(status).title }}
                </div>
              </div>
            </div>
            <!-- < -->
          </div>
        </div>
      </div>
    </div>
    <!-- < map = games -->
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.list {
  user-select: none;

  &__item {
    & + & {
      margin-top: 15px;
    }
  }
}

.game {
  width: 100%;
  min-height: 84px;
  border-radius: 12px;
  background-color: #232e33;

  &__top {
    padding: 20px 0 20px 20px;
    display: flex;
    align-items: center;
  }

  &__status {
    padding-right: 15px;
  }

  &__bottom {
    display: none;

    &.active {
      display: block;
      margin-top: 5px;
      padding: 0px 20px;
    }
  }

  &__img {
    width: 44px;
    height: 44px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }

  &__title {
    font-family: Poppins-Medium;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    user-select: all;
  }

  &__platform {
    margin-top: 7px;
  }

  &__platforms {
    display: flex;
    align-items: center;
  }

  &__platforms-icon {
    display: flex;
    max-height: 12px;
    width: auto;
    opacity: 0.5;

    & + & {
      margin-left: 10px;
    }
  }

  &__subtitle {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.5);
  }

  &__content {
    flex-grow: 1;
    margin-left: 15px;
    margin-right: 15px;
    display: flex;
    align-items: center;
  }

  &__content-status {
    padding-left: 15px;
    margin-left: 15px;
    border-left: 1px solid rgba(151, 151, 151, 0.3);
  }

  &__toggle {
    padding: 10px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    min-width: 40px;
    font-size: 0;
    cursor: pointer;

    * {
      pointer-events: none;
      -webkit-user-drag: none;
    }

    &:hover {
      opacity: 0.5;
    }

    &.active {
      .game__arrow {
        transform: rotate(0);
      }
    }
  }

  &__arrow {
    width: 10px;
    height: 7px;
    display: flex;
    position: relative;
    transform: rotate(180deg);
    transition: all 0.2s;
  }
}

.platforms {
  margin-top: 5px;
  padding-top: 20px;
  padding-bottom: 24px;
  border-top: 1px solid rgba(151, 151, 151, 0.3);

  &__row {
    display: flex;
    align-items: center;
    width: 100%;

    & + & {
      margin-top: 15px;
    }

    &.disabled {
      .action {
        opacity: 0.3;
        pointer-events: none;
        cursor: default;
      }
    }
  }

  &__icon {
    width: 32px;
    height: 32px;
    border-radius: 2.4px;
    background-color: #1d2429;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 16px;
      height: auto;
    }
  }

  &__content {
    display: flex;
    align-items: center;
    flex-grow: 1;
    margin-left: 15px;
    margin-right: 15px;
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: #ffffff;
    user-select: all;
  }

  &__status {
    border-left: 1px solid rgba(151, 151, 151, 0.3);
    padding-left: 15px;
    margin-left: 15px;
  }
}

.status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 15px;
  min-height: 24px;
  min-width: 50px;
  border-radius: 6px;

  &__text {
    font-family: Poppins-Medium;
    font-size: 10px;
    line-height: 15px;
    text-transform: uppercase;
  }

  &.failed {
    background-color: rgba(233, 60, 92, 0.2);
    color: #e93c5c;

    &:before {
      content: '';
      display: block;
      width: 8px;
      height: 7px;
      background-image: url('~@/assets/svg/failed.svg');
      margin-right: 5px;
    }
  }

  &.pending {
    background-color: rgba(255, 193, 7, 0.2);
    color: #ffc107;

    &:before {
      content: '';
      display: block;
      width: 9px;
      height: 9px;
      background-image: url('~@/assets/svg/pending.svg');
      margin-right: 5px;
    }
  }
}

.action {
  font-family: Poppins-Medium;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  transition: all 0.2s;

  &:hover {
    text-decoration: none;
  }

  &.connected {
    color: #e93c5c;
  }

  &.not_connected,
  &.disconnected,
  &.failed {
    color: #38d5b8;
  }

  &.pending {
    color: #5555cc;
    text-decoration: none;
    cursor: default;
  }
}

.action {
  text-decoration: underline;
  cursor: pointer;
}

@media (max-width: $mobile) {
  .list {
    width: 100vw !important;
    margin-left: -15px !important;
    margin-right: -15px !important;

    &__item {
      & + & {
        margin-top: 20px;
      }
    }
  }

  .game {
    border-radius: 0;
    min-height: auto;
    position: relative;
    padding-bottom: 40px;

    &__top {
      padding: 15px 15px 20px;
    }

    &__bottom {
      &.active {
        padding: 0 15px;
      }
    }

    &__action {
      position: absolute;
      bottom: 0;
      left: 0;
      border-top: 1px solid rgba(151, 151, 151, 0.3);
      width: 100%;
      margin-top: 20px;
      min-height: 40px;
      background: rgba(18, 21, 21, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__toggle {
      font-family: Poppins-Regular;
      font-size: 12px;
      line-height: 17px;
      color: #ffc107;
      text-transform: capitalize;

      span {
        margin-right: 10px;
      }

      &:hover {
        opacity: 1;
      }
    }

    &__content {
      margin-right: 0;
    }

    &__content-status {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
      padding-left: 0;
      border: 0;
    }

    &__status {
      padding-right: 0;
    }
  }

  .status {
    min-width: auto;
    min-height: auto;
    border-radius: 0;
    background: transparent !important;
    padding: 0;
  }

  .platforms {
    padding-bottom: 20px;

    .action {
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>
